const footer = {
    text: "We use cookies to make sure our website runs properly. By continuing to use our site we assume you agree",
    button: "Ok!"
}
export default footer;